import { getReportCard, getShakheses } from "@/api/resume";
export default {
  state: {
    shakheses: [],
    reportCard: [],
  },

  mutations: {
    SET_REPORTCARD: (state, data) => {
      state.reportCard = [...data];
    },
    SET_SHAKHESES: (state, data) => {
      state.shakheses = [...data];
    },
  },

  actions: {
    getShakheses({ commit }) {
      commit("SET_TABLE_TEXT", true);
      commit("SET_PROGRESS_SHOW", true);
      return new Promise((resolve, reject) => {
        getShakheses()
          .then((response) => {
            if (!response.data) {
              reject("error");
            }
            var data = response.data;

            commit("SET_SHAKHESES", data);
            commit("SET_TABLE_TEXT", false);
            commit("SET_PROGRESS_SHOW", false);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getReportCard({ commit }, payload) {
      commit("SET_TABLE_TEXT", true);
      commit("SET_PROGRESS_SHOW", true);
      return new Promise((resolve, reject) => {
        getReportCard(payload)
          .then((response) => {
            if (!response.data) {
              reject("error");
            }
            var data = response.data ?? [];

            commit("SET_REPORTCARD", data);
            commit("SET_TABLE_TEXT", false);
            commit("SET_PROGRESS_SHOW", false);
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },

  getters: {},
};
